'use strict';

var _ = require('lodash');
var ConfigurationFoCityAptsTransformerFactory = function ConfigurationFoCityAptsTransformerFactory(DataTransformer, momentService) {
  function ConfigurationFoCityAptsTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'configuration-fo-cityapts-mode';
  }
  ConfigurationFoCityAptsTransformer.prototype = Object.create(DataTransformer.prototype);
  ConfigurationFoCityAptsTransformer.constructor = ConfigurationFoCityAptsTransformer;
  ConfigurationFoCityAptsTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  ConfigurationFoCityAptsTransformer.prototype.isCacheable = function () {
    return false;
  };
  ConfigurationFoCityAptsTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  ConfigurationFoCityAptsTransformer.prototype.transform = function (data) {
    var cityApts = data.domain.cityApts;
    var result = [];
    for (var i = 0; i < cityApts.length; i++) {
      var cityapt = cityApts[i];
      for (var j = 0; j < cityapt.airportDetails.length; j++) {
        var transformedCityApts = getTransformedCityApts(cityapt, cityapt.airportDetails[j]);
        result.push(_.cloneDeep(transformedCityApts));
      }
    }
    return result;
  };
  function getTransformedCityApts(cityApts, airportDetails) {
    var transformedCityApts = cityApts;
    transformedCityApts.carrier = _.toUpper(cityApts.carrier);
    transformedCityApts.routing = cityApts.routing;
    transformedCityApts.originAirport = _.toUpper(cityApts.origin);
    transformedCityApts.destinationAirport = _.toUpper(cityApts.destination);
    transformedCityApts.city = _.toUpper(cityApts.city);
    transformedCityApts.airport = _.toUpper(airportDetails.airport);
    transformedCityApts.lastUpdatedBy = cityApts.lastUpdatedBy;
    transformedCityApts.lastUpdatedAt = momentService.of(cityApts.lastUpdatedAt, momentService.FIELD.SYSTEM_CONFIGURATION_DATE);
    return transformedCityApts;
  }
  return ConfigurationFoCityAptsTransformer;
};
ConfigurationFoCityAptsTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ConfigurationFoCityAptsTransformerFactory;